<template>
	<div class="ic-header">
		<slot>
			<div class="ic-header--title">{{ title }}</div>
		</slot>
		<div v-if="showCloseButton" class="ic-header--close-button" @click="$emit('close')">
			<svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 384 512"><path d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"/></svg>

		</div>
	</div>
</template>

<script lang="ts">
import Vue, { defineComponent } from 'vue';

export default defineComponent({
	name: "PanelHeader",
	emits: ['close'],
	props: {
		title: {
			type: String
		},
		showCloseButton: {
			type: Boolean,
			default: true
		}
	}
})
</script>

<style scoped>
.ic-header {
	background-color: var(--theme-color-primary);
	color: white;
	height: 100%;
	border-top-left-radius: 9px;
	border-top-right-radius: 9px;
	padding: 10px;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
	position: relative;
	box-sizing: border-box;
	display: flex;
}

.ic-header--img {
	border-radius: 50%;
	align-self: center;
	padding: 10px;
}

.ic-header--title {
	align-self: center;
	padding: 10px;
	flex: 1;
	user-select: none;
	font-size: 20px;
}

.ic-header--title.enabled {
	cursor: pointer;
	border-radius: 5px;
}

.ic-header--title.enabled:hover {
	box-shadow: 0px 2px 5px rgba(0.2, 0.2, 0.5, 0.1);
}

.ic-header--close-button {
	width: 50px;
	height: 50px;
	align-self: center;
	margin-right: 10px;
	box-sizing: border-box;
	cursor: pointer;
	border-radius: 5px;
	margin-left: auto;
}

.ic-header--close-button:hover {
	box-shadow: 0px 2px 5px rgba(0.2, 0.2, 0.5, 0.1);
}

.ic-header--close-button img,
.ic-header--close-button svg {
	width: 100%;
	height: 100%;
	padding: 10px;
	box-sizing: border-box;
}

@media (max-width: 450px) {
	.ic-header {
		border-radius: 0px;
	}
}
</style>
